/**
 * @function getPackTotal
 * @summary Get a full price of a pack (before any accessories are removed)
 * @param {*} pack
 */
export const getPackTotal = pack => {
  if (!pack) {
    return 0;
  }

  return pack.isLocked ? pack.price : pack.parts.reduce((prevTotal, accessory) => prevTotal + accessory.price, 0);
};

export const getPackFittingTotal = pack => {
  if (!pack) {
    return 0;
  }

  return pack.isLocked
    ? pack.fittingTime
    : pack.parts.reduce((prevTotal, accessory) => prevTotal + accessory.fittingTime, 0);
};

/**
 * @function cleanPacks
 * @summary Takes an array of packs and filter's each pack's parts out to only
 *          show parts that exist for a bike model.
 * @param {*} packs
 * @param {*} accessories
 */
export const cleanPacks = (packs, accessories) => {
  const accessoryIds = accessories.map(accessory => accessory.id);

  return packs.filter(pack => pack.parts.every(partId => accessoryIds.includes(partId)));
};
